import { useTheme } from '@mui/material';
import Typography from '@mui/material/Typography';

import Button from '@/components/Button';
import Modal from '@/components/Modals/Modal';

interface MLParcelConnectorProps {
  isOpen: boolean;
  onClose: () => void;
  id: string;
  name: string;
  onConnect: (id: string) => void;
}

const MLParcelConnector = ({ isOpen, onClose, id, name, onConnect }: MLParcelConnectorProps) => {
  const theme = useTheme();
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={`Conexión ${name}`}
      actions={
        <Button
          variant="contained"
          onClick={() => {
            onConnect(id);
            onClose();
          }}
        >
          Realizar conexión
        </Button>
      }
    >
      <Typography
        component="div"
        variant="body1"
        sx={{ padding: '1rem', color: theme.palette.grey[500] }}
      >
        Antes de realizar la conexión, asegúrate de cumplir con los siguientes requisitos:
        <br />
        <br />
        <ul style={{ listStylePosition: 'outside', paddingLeft: '20px' }}>
          <li style={{ marginBottom: '1rem' }}>Tener una cuenta activa en Mercado Libre.</li>
          <li style={{ marginBottom: '1rem' }}>Contar con servicios de envíos habilitados.</li>
          <li style={{ marginBottom: '1rem' }}>
            Solo se integran órdenes con modo logístico <strong>personalizado</strong>, sin modo
            definido o ME1. Las órdenes de Flex o Fulfillment no son compatibles.
          </li>
          <li>
            Si acabas de activar el servicio, te recomendamos esperar al menos{' '}
            <strong>24 horas</strong> antes de intentar la conexión, ya que Mercado Libre puede
            tardar ese tiempo en completar la activación.
          </li>
        </ul>
      </Typography>
    </Modal>
  );
};

export default MLParcelConnector;
